import React from 'react'

interface SelectProps {
  children: React.ReactElement | JSX.Element[]
  className: string | undefined
  placeholder: string
  [rest: string]: any
};

const Select: React.FC<SelectProps> = ({ children, className, ...rest }: SelectProps) => {
  return (
    <div className='relative'>
      <select className={`font-primary bg-transparent text-dopage-lightGreen outline-0 border-[3px] rounded border-dopage-lightGreen ${className ?? ''}`} {...rest}>
        {children}
      </select>
    </div>
  )
}

export default Select
